import React from 'react';
import { Map } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface MapChartIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const MapChartIcon: React.FC<MapChartIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <Map size={size} color={color} />
        </IconWrapper>
    );
};
